// @ts-ignore-line
// eslint-disable-next-line import/no-webpack-loader-syntax
import mapbox from "!mapbox-gl";
import { MapStyle } from "../../types";
// import { CircleInput } from "./borders/circle";
import { FrameInput, frame } from "./borders/frame";
import { BorderInput } from "./borders/types";
import { Border, BorderStyle, Layout, PaperSize } from "./types";
import { colors } from "../../colors";

export const StyleInfo: Record<MapStyle, { name: string, color: string }> = {
  [MapStyle.NATURAL]: { name: "Natural", color: "#86CE85" },
  [MapStyle.BLUE]: {name: "Blue", color: "#12345F" },
  [MapStyle.TERRAIN]: { name: "Terrain", color: "#68432D" },
  [MapStyle.SATELLITE]: { name: "Satellite", color: "#1F4887" },
  [MapStyle.LIGHT]: {name: "White", color: "#9e9e9e" },
  [MapStyle.DARK]: {name: "Black", color: "#000000" },
  [MapStyle.GREY]: {name: "Grey", color: "#BDBDBD" },
  [MapStyle.LOVE]: {name: "Love", color: "#D9A5BF" },
  [MapStyle.FOREST]: { name: "Forest", color: "#CB997E" },
  [MapStyle.WOOD]: {name: "Wood", color: "#964B00" },
  [MapStyle.CARTOON]: {name: "Cartoon", color: "#6BBEBE" },
  [MapStyle.DARK_GREEN]: {name: "Dark Green", color: "#2E7D32" },
  [MapStyle.PINK]: {name: "Pink", color: "#E91E63" },
  [MapStyle.YELLOW]: {name: "Yellow", color: "#FFC107" },
  [MapStyle.MAGENTA]: {name: "Magenta", color: "#E91E63" },
  [MapStyle.DARK_RED]: {name: "Dark Red", color: "#B71C1C" },
  [MapStyle.ORANGE]: {name: "Orange", color: "#FF9800" },
  [MapStyle.RED]: {name: "Red", color: "#F44336" },
  [MapStyle.TEAL]: {name: "Teal", color: "#009688" },
  [MapStyle.BEIGE]: {name: "Beige", color: "#D7CCC8" },
  [MapStyle.GREEN]: {name: "Green", color: "#4CAF50" },
  [MapStyle.PURPLE]: {name: "Purple", color: "#9C27B0" },
  [MapStyle.DARK_CYAN]: {name: "Dark Cyan", color: "#00695C" },
  [MapStyle.DARK_TURQUOISE]: {name: "Dark Turquoise", color: "#00838F" },
}

export const LayoutInfo: Record<Layout, { name: string, heightPxPerWidthPx: number, suffix: string }> = {
  [Layout.PORTRAIT]: {
    name: "Portrait",
    suffix: "",
    heightPxPerWidthPx: Math.SQRT2,
  },
  [Layout.LANDSCAPE]: {
    name: "Landscape",
    suffix: "ls",
    heightPxPerWidthPx: Math.SQRT1_2,
  },
  [Layout.SQUARE]: {
    name: "Square",
    suffix: "sq",
    heightPxPerWidthPx: 1,
  },
};

export const BorderInfo: Record<BorderStyle, {
  name: string,
  id: Border,
  input: BorderInput,
  initialState: any,
  drawFn: (map: mapbox.Map, state: any) => void;
}> = {
  [BorderStyle.NONE]: {
    name: "None",
    id: Border.NONE,
    input: () => null,
    initialState: {},
    drawFn: () => undefined,
  },
  [BorderStyle.SIMPLE]: {
    name: "Simple",
    id: Border.FRAME,
    input: FrameInput,
    drawFn: frame,
    initialState: {
      border: Border.FRAME,
      fade: "#FFFFFF",
      frames: [
        { thickness: 0.05, color: "#000000" },
        { thickness: 0.01, color: "#FFFFFF" },
      ],
      text: {
        primary: {
          color: "#000000",
          value: "Primary",
        },
        secondary: {
          color: "#000000",
          value: "Secondary",
        },
        subtitle: {
          color: "#999999",
          value: "Subtitle",
        }
      }
    },
  },
  [BorderStyle.TRANSPARENT]: {
    name: "Transparent",
    id: Border.FRAME,
    input: FrameInput,
    drawFn: frame,
    initialState: {
      border: Border.FRAME,
      fade: "#FFFFFF",
      frames: [
        { thickness: 0.06, color: "#88888844" },
        { thickness: 0.01, color: "#000000" },
      ],
      text: {
        primary: {
          color: colors.text.inverse,
          value: "Primary",
        },
        secondary: {
          color: colors.text.inverse,
          value: "Secondary",
        },
        subtitle: {
          color: "#999999",
          value: "Subtitle",
        }
      }
    },
  },
  [BorderStyle.FANCY]: {
    name: "Fancy",
    id: Border.FRAME,
    input: FrameInput,
    drawFn: frame,
    initialState: {
      border: Border.FRAME,
      fade: "#FFFFFF",
      frames: [
        { thickness: 0.05, color: "#000000" },
        { thickness: 0.01, color: "#FFFFFF" },
        { thickness: 0.01, color: "#000000" },
        { thickness: 0.005, color: "#FFFFFF" },
      ],
      text: {
        primary: {
          color: colors.text.inverse,
          value: "Primary",
        },
        secondary: {
          color: colors.text.inverse,
          value: "Secondary",
        },
        subtitle: {
          color: "#999999",
          value: "Subtitle",
        }
      }
    },
  },
};

export const PaperInfo: Record<PaperSize, { name: string, fileSize: string }> = {
  [PaperSize.A4]: {
    name: "A4",
    fileSize: "1MB",
  },
  [PaperSize.A3]: {
    name: "A3",
    fileSize: "4MB",
  },
  [PaperSize.A2]: {
    name: "A2",
    fileSize: "15MB",
  },
  [PaperSize.A1]: {
    name: "A1",
    fileSize: "60MB",
  },
};
